import { socialLinksComponent } from './social-links.component';
import { SocialLinksService } from './social-links.service';
import './social-links.scss';

export const socialLinks = angular
    .module('components.socialLinks', [])
    .service('SocialLinksService', SocialLinksService)
    .component('socialLinks', socialLinksComponent)
    .name;


// WEBPACK FOOTER //
// ./src/app/components/social-links/social-links.module.js